module.exports = __webpack_public_path__ + "media/images/official/top_mv2_sp-d6943143224bed193e0d14cae38bdbd3.jpg";